import _styled from "styled-components";
import { Trans, useTranslation } from "react-i18next";
import triggerResize from "../../../../Core/triggerResize";
import Icon from "../../../../Styled/Icon";
import Text from "../../../../Styled/Text";
import Prompt from "../../../Generic/Prompt";
import { useRefForTerria } from "../../../Hooks/useRefForTerria";
import Styles from "./story-button.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const STORY_BUTTON_NAME = "MenuBarStoryButton";
export const onStoryButtonClick = props => () => {
  props.viewState.toggleStoryBuilder();
  props.terria.currentViewer.notifyRepaintRequired();
  // Allow any animations to finish, then trigger a resize.
  setTimeout(function () {
    triggerResize();
  }, props.animationDuration || 1);
  props.viewState.toggleFeaturePrompt("story", false, true);
};
const promptHtml = hasStories => /*#__PURE__*/_jsx(Text, {
  textLight: true,
  textAlignCenter: true,
  children: hasStories ? /*#__PURE__*/_jsx(Trans, {
    i18nKey: "story.promptHtml1",
    children: /*#__PURE__*/_jsx(Text, {
      extraLarge: true,
      children: "You can view and create stories at any time by clicking here."
    })
  }) : /*#__PURE__*/_jsx(Trans, {
    i18nKey: "story.promptHtml2",
    children: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(Text, {
        children: "INTRODUCING"
      }), /*#__PURE__*/_jsx(Text, {
        bold: true,
        extraExtraLarge: true,
        styledLineHeight: "32px",
        children: "Data Stories"
      }), /*#__PURE__*/_jsx(Text, {
        medium: true,
        children: "Create and share interactive stories directly from your map."
      })]
    })
  })
});
const StoryButton = props => {
  const storyButtonRef = useRefForTerria(STORY_BUTTON_NAME, props.viewState);
  const storyEnabled = props.terria.configParameters.storyEnabled;
  const dismissAction = () => {
    props.viewState.toggleFeaturePrompt("story", false, true);
  };
  const delayTime = storyEnabled && props.terria.stories.length > 0 ? 1000 : 2000;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs(_StyledButton, {
      ref: storyButtonRef,
      className: Styles.storyBtn,
      type: "button",
      onClick: onStoryButtonClick(props),
      "aria-expanded": props.viewState.storyBuilderShown,
      children: [/*#__PURE__*/_jsx(Icon, {
        glyph: Icon.GLYPHS.story
      }), /*#__PURE__*/_jsx("span", {
        children: t("story.story")
      })]
    }), /*#__PURE__*/_jsx(Prompt, {
      centered: true,
      isVisible: storyEnabled && props.viewState.featurePrompts.indexOf("story") >= 0,
      content: promptHtml(props.terria.stories.length > 0),
      displayDelay: delayTime,
      dismissText: t("story.dismissText"),
      dismissAction: dismissAction
    })]
  });
};
export default StoryButton;
var _StyledButton = _styled("button").withConfig({
  displayName: "StoryButton___StyledButton",
  componentId: "sc-l18jw-0"
})(["", ""], p => p["aria-expanded"] && "&:not(.foo) {\n                      background: ".concat(p.theme.colorPrimary, ";\n                      svg {\n                        fill: ").concat(p.theme.textLight, ";\n                      }\n                    }"));